import { Link } from "react-router-dom";

interface InspirationCardProps {
  emoji: string;
  label: string;
  slug: string;
  subtitle?: string;
  count?: number;
  delay?: number;
}

const InspirationCard = ({ emoji, label, slug, subtitle, count, delay = 0 }: InspirationCardProps) => (
  <div
    className="shrink-0 anim-fade-in-scale"
    style={{ width: "calc(50% - 6px)", animationDelay: `${delay}s` }}
  >
    <div
      className="flex flex-col items-center justify-center rounded-2xl bg-background px-4 py-8"
      style={{ minHeight: "200px" }}
    >
      <p className="text-sm text-muted-foreground text-center italic">In progress..</p>
    </div>
  </div>
);

export default InspirationCard;
